export { default } from "./TableManagementAdd";
